let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j5L0R")).then(() => parcelRequire('daxmT'));